
    import './styles.scoped.css';
    export default {
  "trigger": "awsui_trigger_lpshu_s3nsx_145",
  "trigger-with-badge": "awsui_trigger-with-badge_lpshu_s3nsx_157",
  "selected": "awsui_selected_lpshu_s3nsx_175",
  "trigger-wrapper": "awsui_trigger-wrapper_lpshu_s3nsx_186",
  "dot": "awsui_dot_lpshu_s3nsx_211"
};
  